import Keycloak from 'keycloak-js';

export const keycloakOptions: Keycloak.KeycloakInitOptions = {
  redirectUri: window.location.origin
};
